import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad3ddfa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_step_item_title = _resolveComponent("step-item-title")!
  const _component_joy_selectable_item = _resolveComponent("joy-selectable-item")!
  const _component_joy_selectable_item_group = _resolveComponent("joy-selectable-item-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_step_item_title, {
      "is-optional": true,
      "data-testid": "profile-creation-seniority-title"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.seniority.title')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "seniorityLevel__subtitle",
      innerHTML: _ctx.$msg('profile.creation.completion.wizard.seniority.subtitle')
    }, null, 8, _hoisted_1),
    _createVNode(_component_joy_selectable_item_group, {
      "full-width": "",
      onJoySelectableItemGroupChange: _ctx.selectSeniorityLevel
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seniorityLevels, (seniorityLevel) => {
          return (_openBlock(), _createBlock(_component_joy_selectable_item, {
            key: seniorityLevel,
            value: seniorityLevel,
            "data-testid": _ctx.seniorityLevelId(seniorityLevel)
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$msg(`profile.creation.completion.wizard.details.seniority.${seniorityLevel}`)), 1)
            ]),
            _: 2
          }, 1032, ["value", "data-testid"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onJoySelectableItemGroupChange"])
  ]))
}